import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import NumberFormat from "react-number-format";
import { change_Lang } from "../../../actions/Helper_action";
import { Search, User, PhoneCall, Activity, Home } from "react-feather";
import { Button, Input, Modal, Select, Tooltip } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  All_List_Sell_Property,
  View_All_Sell,
} from "../../../actions/Project_action";
import { Delete_Property } from "../../../actions/Property_action";
import Swal from "sweetalert2";
import { isMobile } from "react-device-detect";
const AllSellProperty = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.HelperReducer.lang);
  const view_sels = useSelector((state) => state.ProjectReducer.view_sels);
  const all_sell_property = useSelector(
    (state) => state.ProjectReducer.all_sell_property
  );
  const S_L_status = useSelector((state) => state.ProjectReducer.S_L_status);
  useEffect(() => {
    dispatch(All_List_Sell_Property());
  }, []);
  const [search, setsearch] = useState("");
  const [select_type_property, setselect_type_property] = useState("");
  const [select_status_property, setselect_status_property] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const showModal = (id) => {
    dispatch(View_All_Sell(id));
    setIsModalVisible(true);
  };
  const onDelete_Property = (id) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      html: `<label class="fk">${dispatch(
        change_Lang("You won't be able to delete this!")
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Delete_Property(id));
        dispatch(All_List_Sell_Property());
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };
  const handleChange_StatusProperty = (value) => {
    setselect_status_property(value);
  };
  const handleChange_SelectProperty = (value) => {
    setselect_type_property(value);
  };
  const datas = all_sell_property
    .filter((data) => {
      if (data.status !== "delete" && data.status !== "Rejected") {
        if (isNaN(search)) {
          if (
            data.block &&
            data.block.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.block &&
              data.block.toLowerCase().startsWith(search.toLowerCase())
            );
          } else if (
            data.Owner_name &&
            data.Owner_name.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.Owner_name &&
              data.Owner_name.toLowerCase().startsWith(search.toLowerCase())
            );
          } else if (
            data.Place_ku &&
            data.Place_ku.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.Place_ku &&
              data.Place_ku.toLowerCase().startsWith(search.toLowerCase())
            );
          }
        } else if (select_type_property === "Apartment") {
          return data.Property && data.Property === "Apartment";
        } else if (select_type_property === "House") {
          return data.Property && data.Property === "House";
        } else if (select_type_property === "Farm") {
          return data.Property && data.Property === "Farm";
        } else if (select_type_property === "Shop") {
          return data.Property && data.Property === "Shop";
        } else if (select_type_property === "Vella") {
          return data.Property && data.Property === "Vella";
        } else if (select_type_property === "Earth") {
          return data.Property && data.Property === "Earth";
        } else if (select_type_property === "The gas station") {
          return data.Property && data.Property === "The gas station";
        } else if (select_type_property === "Factory") {
          return data.Property && data.Property === "Factory";
        } else if (select_type_property === "GYM") {
          return data.Property && data.Property === "GYM";
        } else if (select_type_property === "store") {
          return data.Property && data.Property === "store";
        } else if (select_type_property === "Restaurant") {
          return data.Property && data.Property === "Restaurant";
        } else if (select_type_property === "Commercial Land") {
          return data.Property && data.Property === "Commercial Land";
        } else if (select_type_property === "Company") {
          return data.Property && data.Property === "Company";
        } else if (select_type_property === "Hotel") {
          return data.Property && data.Property === "Hotel";
        } else if (select_type_property === "Car Garage") {
          return data.Property && data.Property === "Car Garage";
        } else if (select_type_property === "Stadium") {
          return data.Property && data.Property === "Stadium";
        } else if (select_type_property === "Car wash") {
          return data.Property && data.Property === "Car wash";
        } else if (select_type_property === "Building") {
          return data.Property && data.Property === "Building";
        } else if (select_type_property === "Agitator") {
          return data.Property && data.Property === "Agitator";
        } else if (select_type_property === "residential community") {
          return data.Property && data.Property === "residential community";
        } else if (
          select_type_property === "agricultural land of the register"
        ) {
          return (
            data.Property &&
            data.Property === "agricultural land of the register"
          );
        } else if (select_type_property === "unregistered agricultural land") {
          return (
            data.Property && data.Property === "unregistered agricultural land"
          );
        } else if (select_type_property === "Government agricultural land") {
          return (
            data.Property && data.Property === "Government agricultural land"
          );
        } else if (select_type_property === "Land of Istamar") {
          return data.Property && data.Property === "Land of Istamar";
        } else if (select_type_property === "Erth Musataha") {
          return data.Property && data.Property === "Erth Musataha";
        } else if (select_type_property === "school") {
          return data.Property && data.Property === "school";
        } else if (select_type_property === "Building of Istamar") {
          return data.Property && data.Property === "Building of Istamar";
        } else if (select_type_property === "Building of Musataha") {
          return data.Property && data.Property === "Building of Musataha";
        } else if (select_status_property === "sold") {
          return data.status === "sold";
        } else if (select_status_property === "deactive") {
          return data.status === "deactive";
        } else if (select_status_property === "active") {
          return data.status === "active";
        } else {
          if (data.price && data.price.toString().startsWith(search)) {
            return data.price && data.price.toString().startsWith(search);
          } else if (
            data.NOoFProperty &&
            data.NOoFProperty.toString().startsWith(search)
          ) {
            return (
              data.NOoFProperty &&
              data.NOoFProperty.toString().startsWith(search)
            );
          } else if (data.Area && data.Area.toString().startsWith(search)) {
            return data.Area && data.Area.toString().startsWith(search);
          } else {
            return data.Phone && data.Phone.toString().startsWith(search);
          }
        }
      }
    })
    .filter((element) => {
      if (select_status_property && select_type_property) {
        return (
          element.Property === select_type_property &&
          element.status === select_status_property
        );
      } else {
        return element;
      }
    })
    .filter((element) => {
      if (search && select_type_property) {
        return (
          element.Property === select_type_property &&
          (element.Area === search ||
            element.Place_ku === search ||
            element.block === search)
        );
      } else {
        return element;
      }
    })
    .filter((element) => {
      if (search && select_type_property && select_status_property) {
        return (
          element.Property === select_type_property &&
          (element.Area === search ||
            element.Place_ku === search ||
            element.block === search) &&
          element.status === select_status_property
        );
      } else {
        return element;
      }
    })
    .map((el, i) => {
      return {
        id: i + 1,
        action: (
          <>
            <Tooltip title="View">
              <Button
                style={{ background: "#efefed", color: "#295a68" }}
                shape="circle"
                onClick={() => showModal(el._id)}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-eye text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete">
              <Button
                style={{ background: "#efefed", color: "#295a68" }}
                shape="circle"
                onClick={() => onDelete_Property(el._id)}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-ban text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
          </>
        ),
        Owner_name: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.Owner_name}
          </span>
        ),
        Place_en: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {lang === "en"
              ? el.Place_en
              : lang === "krd"
              ? el.Place_ku
              : el.Place_ar}
          </span>
        ),
        Area: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.Area}&nbsp;م<sup>2</sup>
          </span>
        ),
        phone: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.Phone}</span>
        ),
        property: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el && dispatch(change_Lang(el.Property))}
          </span>
        ),
        price: (
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={el.price}
            className={`${lang === "en" ? "" : "fk"}`}
            prefix="$"
          />
        ),
        NOoFProperty: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.Property !== "Apartment"
              ? el.NOoFProperty
              : `${el.block}-${el.flour}-${el.NOoFProperty}`}
          </span>
        ),
        status:
          el.status === "active" ? (
            <label
              className={`${lang === "en" ? "" : "fk"}`}
              style={{
                color: "green",
                background: "#efefed",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            >
              {dispatch(change_Lang(el.status))}
            </label>
          ) : el.status === "deactive" ? (
            <label
              className={`${lang === "en" ? "" : "fk"}`}
              style={{
                color: "red",
                background: "#efefed",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            >
              {dispatch(change_Lang(el.status))}
            </label>
          ) : el.status === "sold" ? (
            <label
              className={`${lang === "en" ? "" : "fk"}`}
              style={{
                color: "#e78721",
                background: "#efefed",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            >
              {dispatch(change_Lang(el.status))}
            </label>
          ) : (
            ""
          ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("id")),
      selector: "id",
      sortable: true,
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Type of property")),
      selector: "property",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("profile_location")),
      selector: "Place_en",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Area")),
      selector: "Area",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Number of property")),
      selector: "NOoFProperty",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("pr_price")),
      selector: "price",
      center: true,
      compact: true,
    },

    {
      name: dispatch(change_Lang("d_status")),
      selector: "status",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Action")),
      selector: "action",
      center: true,
      compact: true,
    },
  ];
  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  const { Option } = Select;
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("Sell Property List"))}
          parent={dispatch(change_Lang("Property List"))}
        />
        {S_L_status !== true ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div
              className={`${
                lang === "en" ? "container-fluid" : "container-fluid fk"
              }`}
            >
              <div className="row">
                <div className="col-xs-12 col-sm-12 ">
                  <div className={isMobile ? "" : "card"}>
                    <div className="row ">
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-2"></div>
                          <div
                            className={
                              isMobile
                                ? "col-md-5 mt-4 d-flex justify-content-center"
                                : "col-md-5 mt-4 d-flex justify-content-start"
                            }
                          >
                            <Select
                              value={select_type_property}
                              onChange={handleChange_SelectProperty}
                              defaultValue={dispatch(change_Lang("Choose"))}
                              className="fk text-center mt-2"
                              size="middle"
                              showSearch
                              optionFilterProp="children"
                              filterOption={true}
                              style={{
                                fontSize: "16px",
                                borderBottomColor: "#052f43",
                                width: "200px",
                              }}
                              showArrow={false}
                            >
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value=""
                              >
                                {dispatch(change_Lang("Choose"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Apartment"
                              >
                                {dispatch(change_Lang("Apartment"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="House"
                              >
                                {dispatch(change_Lang("House"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Farm"
                              >
                                {dispatch(change_Lang("Farm"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Shop"
                              >
                                {dispatch(change_Lang("Shop"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Vella"
                              >
                                {dispatch(change_Lang("Vella"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Earth"
                              >
                                {dispatch(change_Lang("Earth"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Commercial Land"
                              >
                                {dispatch(change_Lang("Commercial Land"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Company"
                              >
                                {dispatch(change_Lang("Company"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Hotel"
                              >
                                {dispatch(change_Lang("Hotel"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Car Garage"
                              >
                                {dispatch(change_Lang("Car Garage"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Stadium"
                              >
                                {dispatch(change_Lang("Stadium"))}
                              </Option>
                              <Option
                                value={"Car wash"}
                                className="fk"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("Car wash"))}
                              </Option>
                              <Option
                                value={"The gas station"}
                                className="fk"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("The gas station"))}
                              </Option>
                              <Option
                                value={"Factory"}
                                className="fk"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("Factory"))}
                              </Option>
                              <Option
                                value={"GYM"}
                                className="fk"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("GYM"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"palace"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("palace"))}
                              </Option>
                              <Option
                                value={"store"}
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("store"))}
                              </Option>
                              <Option
                                value={"Restaurant"}
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("Restaurant"))}
                              </Option>
                              {/* new one */}
                              <Option
                                className="fk"
                                value={"Building"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Building"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"Agitator"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Agitator"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"residential community"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("residential community"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"agricultural land of the register"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(
                                  change_Lang(
                                    "agricultural land of the register"
                                  )
                                )}
                              </Option>
                              <Option
                                className="fk"
                                value={"unregistered agricultural land"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(
                                  change_Lang("unregistered agricultural land")
                                )}
                              </Option>
                              <Option
                                className="fk"
                                value={"Government agricultural land"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(
                                  change_Lang("Government agricultural land")
                                )}
                              </Option>
                              <Option
                                className="fk"
                                value={"Land of Istamar"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Land of Istamar"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"Erth Musataha"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Erth Musataha"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"school"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("school"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"Building of Istamar"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Building of Istamar"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"Building of Musataha"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Building of Musataha"))}
                              </Option>
                            </Select>
                          </div>
                          <div
                            className={
                              isMobile
                                ? "col-md-5 mt-4 d-flex justify-content-center"
                                : "col-md-5 mt-4 d-flex justify-content-start"
                            }
                          >
                            <Select
                              value={select_status_property}
                              onChange={handleChange_StatusProperty}
                              defaultValue={dispatch(change_Lang("d_status"))}
                              className="fk text-center mt-2"
                              size="middle"
                              showSearch
                              optionFilterProp="children"
                              filterOption={true}
                              style={{
                                fontSize: "16px",
                                borderBottomColor: "#052f43",
                                width: "200px",
                              }}
                              showArrow={false}
                            >
                              <Option className="fk" value={""}>
                                {dispatch(change_Lang("d_status"))}
                              </Option>
                              <Option
                                style={{ color: "green" }}
                                value="active"
                                className="fk"
                              >
                                {dispatch(change_Lang("Unsold"))}
                              </Option>
                              <Option
                                value="sold"
                                style={{ color: "#e78721" }}
                                className="fk"
                              >
                                {" "}
                                {dispatch(change_Lang("sold"))}
                              </Option>
                              <Option
                                value="deactive"
                                style={{ color: "red" }}
                                className="fk"
                              >
                                {dispatch(change_Lang("deactive"))}
                              </Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          isMobile ? "col-md-5" : "col-md-5 card-header"
                        }
                      >
                        <div className=" text-center mt-2">
                          <h3 style={{ fontWeight: "bold", color: "#295a68" }}>
                            {dispatch(change_Lang("Sell Property List"))}
                          </h3>
                        </div>
                      </div>
                      <div className="col-md-3 m-auto">
                        <div className="form-group form-inline d-flex justify-content-center">
                          <Input
                            type="text"
                            name="search"
                            value={search}
                            onChange={(e) => setsearch(e.target.value)}
                            size="middle"
                            placeholder={dispatch(change_Lang("Search"))}
                            autoComplete="off"
                            className="mt-2 ml-2"
                            style={{ width: "180px" }}
                            prefix={<Search color="lightgray" />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="user-status table-responsive latest-order-table">
                      <DataTable
                        columns={columns}
                        className={`${lang === "en" ? "" : "fk"}`}
                        customStyles={customStyles}
                        data={datas}
                        pagination={true}
                        noDataComponent={dispatch(change_Lang("table_display"))}
                        striped
                        // key={datas}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <Modal
          title=" "
          width={1100}
          hight
          footer={false}
          open={isModalVisible}
          onOk={handleCancel}
          onCancel={handleCancel}
        >
          <div className=" fk">
            <div className="row product-page-main card-body">
              <div className="col-xl-4">
                <Slider className="product-slider">
                  {view_sels
                    ? view_sels.image_property.map((el, i) => {
                        return (
                          <div className="item">
                            <img
                              style={{ width: "554px", height: "300px" }}
                              className="img-fluid image_zoom_cls-0"
                              src={`/${el}`}
                              alt=""
                            />
                          </div>
                        );
                      })
                    : ""}
                </Slider>

                {/* <Slider
                  asNavFor={nav1}
                  // ref={(slider) => (this.slider2 = slider)}
                  slidesToShow={
                    view_sels?view_sels.image_property.length === 3:""
                      ? 3
                      : view_sels?view_sels.image_property.length === 2:""
                      ? 2
                      : 1
                  }
                  slidesToScroll={1}
                  swipeToSlide={true}
                  focusOnSelect={true}
                  className="small-slick"
                >
                  {view_sels?view_sels.image_property.map((el, i) => {
                    return (
                      <div className="item">
                        <img
                          className="img-fluid"
                          src={`/${
                            view_sels.image_property.length === 1 ? "" : el
                          }`}
                          alt=""
                        />
                      </div>
                    );
                  }):""}
                </Slider> */}
                <div className="add-product-form mt-3">
                  <h3 className="product-page-details product-right mb-0">
                    {dispatch(change_Lang("Agent_name"))}
                  </h3>
                  {lang === "en" ? (
                    <div className="product-price digits mt-2">
                      <h4 style={{ color: "darkblack" }}>
                        <User />
                        &nbsp;&nbsp;
                        {`${
                          view_sels &&
                          view_sels.agentId &&
                          view_sels.agentId.fname
                        } ${
                          view_sels &&
                          view_sels.agentId &&
                          view_sels.agentId.lname
                        }`}{" "}
                      </h4>
                    </div>
                  ) : (
                    <div className="product-price digits mt-2">
                      <h4 style={{ color: "darkblack" }}>
                        {`${
                          view_sels
                            ? view_sels.agentId && view_sels.agentId.fname
                            : ""
                        } ${
                          view_sels
                            ? view_sels.agentId && view_sels.agentId.lname
                            : ""
                        }`}
                        &nbsp;&nbsp;
                        <User />
                      </h4>
                    </div>
                  )}
                  {lang === "en" ? (
                    <div className="product-price digits mt-2">
                      <h4 style={{ color: "#212d5e" }}>
                        <PhoneCall />
                        &nbsp;&nbsp;
                        {view_sels
                          ? view_sels.agentId && view_sels.agentId.phone
                          : ""}{" "}
                      </h4>
                    </div>
                  ) : (
                    <div className="product-price digits mt-2">
                      <h4 style={{ color: "#212d5e" }}>
                        {view_sels
                          ? view_sels.agentId && view_sels.agentId.phone
                          : ""}
                        &nbsp;&nbsp;
                        <PhoneCall />
                      </h4>
                    </div>
                  )}
                </div>
                <div className="add-product-form mt-3">
                  <h3 className="product-page-details product-right mb-0">
                    {dispatch(change_Lang("Name of Branch"))}
                  </h3>
                  {lang === "en" ? (
                    <div className="product-price digits mt-2">
                      <h4 style={{ color: "darkblack" }}>
                        <Home />
                        &nbsp;&nbsp;
                        {`${
                          view_sels
                            ? view_sels.branchId && view_sels.branchId.name
                            : ""
                        }`}
                      </h4>
                    </div>
                  ) : (
                    <div className="product-price digits mt-2">
                      <h4 style={{ color: "darkblack" }}>
                        {`${
                          view_sels
                            ? view_sels.branchId && view_sels.branchId.name
                            : ""
                        }`}
                        &nbsp;&nbsp;
                        <Home />
                      </h4>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-xl-8">
                <div className="product-page-details product-right mb-0">
                  <h2>
                    {lang === "en"
                      ? view_sels
                        ? view_sels.Place_en
                        : ""
                      : lang === "krd"
                      ? view_sels
                        ? view_sels.Place_ku
                        : ""
                      : view_sels
                      ? view_sels.Place_ar
                      : ""}
                  </h2>
                  <hr />
                  <h6 className="product-title ">
                    {dispatch(change_Lang("Description"))}
                  </h6>
                  <p className="">
                    {lang === "en"
                      ? view_sels
                        ? view_sels.disc_en
                        : ""
                      : lang === "krd"
                      ? view_sels
                        ? view_sels.disc_ku
                        : ""
                      : view_sels
                      ? view_sels.disc_ar
                      : ""}
                  </p>
                  <div className="product-price digits mt-2 ">
                    {lang === "en" ? (
                      <h3>
                        <i className="fas fa-tag"></i>&nbsp;Price:&nbsp; ${""}{" "}
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={view_sels ? view_sels.price : ""}
                        />
                      </h3>
                    ) : (
                      <h3>
                        <i className="fas fa-tag"></i>&nbsp;نرخ:&nbsp;
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={view_sels ? view_sels.price : ""}
                        />{" "}
                        $
                      </h3>
                    )}
                  </div>
                  <div className="product-price digits mt-2">
                    {lang === "en" ? (
                      <h3>
                        <i className="far fa-object-group">&nbsp;Area:</i>
                        &nbsp;
                        {view_sels ? view_sels.Area : ""} m
                      </h3>
                    ) : (
                      <h3>
                        <i className="far fa-object-group">&nbsp;ڕووبەر:</i>
                        &nbsp;
                        {view_sels ? view_sels.Area : ""} م
                      </h3>
                    )}
                  </div>
                  <ul className="product-price digits mt-2">
                    <h3>
                      {" "}
                      <i className="far fa-building"></i>&nbsp;
                      {dispatch(change_Lang("first_rule_Property_type"))}
                      :&nbsp;
                      {view_sels
                        ? dispatch(change_Lang(view_sels.Property))
                        : ""}
                    </h3>
                  </ul>
                  <ul className="product-price digits mt-2">
                    <h3>
                      <i className="fas fa-inbox"></i>&nbsp;
                      {dispatch(change_Lang("property_just"))}
                      :&nbsp;
                      {view_sels
                        ? dispatch(change_Lang(view_sels.Type_property))
                        : ""}
                    </h3>
                  </ul>
                  <hr />
                  <div className="add-product-form">
                    <h2 className="product-page-details product-right mb-0">
                      {dispatch(change_Lang("Owner Detail"))}
                    </h2>
                    {lang === "en" ? (
                      <div className="product-price digits mt-2">
                        <h4 style={{ color: "darkblack" }}>
                          <User />
                          &nbsp;&nbsp;{view_sels
                            ? view_sels.Owner_name
                            : ""}{" "}
                        </h4>
                      </div>
                    ) : (
                      <div className="product-price digits mt-2">
                        <h4 style={{ color: "darkblack" }}>
                          {view_sels ? view_sels.Owner_name : ""}&nbsp;&nbsp;
                          <User />
                        </h4>
                      </div>
                    )}
                    {lang === "en" ? (
                      <div className="product-price digits mt-2">
                        <h4 style={{ color: "#212d5e" }}>
                          <PhoneCall />
                          &nbsp;&nbsp;{view_sels ? view_sels.Phone : ""}{" "}
                        </h4>
                      </div>
                    ) : (
                      <div className="product-price digits mt-2">
                        <h4 style={{ color: "#212d5e" }}>
                          {view_sels ? view_sels.Phone : ""}&nbsp;&nbsp;
                          <PhoneCall />
                        </h4>
                      </div>
                    )}
                    {lang === "en" ? (
                      <div className="product-price digits mt-2">
                        <h4
                          style={{
                            color: `${
                              view_sels
                                ? view_sels.status === "active"
                                  ? "darkgreen"
                                  : view_sels
                                  ? view_sels.status === "deactive"
                                  : ""
                                  ? "darkred"
                                  : "#e78721"
                                : ""
                            }`,
                          }}
                        >
                          <Activity />
                          &nbsp;&nbsp;{view_sels ? view_sels.status : ""}
                        </h4>
                      </div>
                    ) : (
                      <div className="product-price digits mt-2">
                        <h4
                          style={{
                            color: `${
                              view_sels
                                ? view_sels.status === "active"
                                  ? "darkgreen"
                                  : view_sels
                                  ? view_sels.status === "deactive"
                                  : ""
                                  ? "darkred"
                                  : "#e78721"
                                : ""
                            }`,
                          }}
                        >
                          {view_sels ? view_sels.status : ""}&nbsp;&nbsp;
                          <Activity />
                        </h4>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    </>
  );
};

export default AllSellProperty;
